import React from 'react';
import { secureWebComponents } from '../helpers/secureWebComponents.js';
const Countdown = secureWebComponents(({
  title,
  timestamp,
  color = 'var(--bosch-blue-85)'
}) => /*#__PURE__*/React.createElement("ebds-countdown", {
  title: title,
  timestamp: timestamp,
  color: color
}));
export default Countdown;